<template>
  <div>
    <div class="row mx-0 nav flex-nowrap flex-xl-wrap d-flex mobile-scroll"
         :class="[disableDefaultTabStructure ? '' : `${padding} ls-bg-white nav-tabs`]">
      <template v-for="(tab, key) in tabs">
        <slot name="tab-head"
              :loadTab="loadTab"
              :itemKey="key"
              :tab="tab">
          <a class="nav-item nav-link ls__nav-link mouse-click"
             :class="[tab.active ? 'active show' : '']"
             :id="`nav-${tab.name}-tab`"
             :aria-controls="`#nav-${tab.name}`"
             :key="key" @click="loadTab(key)"
             v-if="!tab.hide">
            <div class="d-flex align-items-center ls-tabs">
              <div v-if="tab.icon && !tab.fa_icon" class="mr-2">
                <img :src="tab.icon" height="25" width="25" alt=""/>
              </div>
              <div v-if="tab.fa_icon" class="mr-2">
                <span class="tab-icon" :class="[tab.active ? ' active-icon' : '']"><i class="fa" :class="[tab.fa_icon ? tab.fa_icon : '']"></i></span>
              </div>
              <span :class="tab.isDisable ? 'c-9e9e9e' : ''">
                {{ tab.title }}
              </span>
            </div>
          </a>
        </slot>
      </template>
    </div>
    <div class="ls-separator d-none d-lg-block"></div>
    <div class="tab-content" :class="[disableDefaultTabStructure || disableContentStructure || disablePadding ? 'pt-3' : 'ls-bg-white py-3', disableContentStructure ? 'ls-bg-white' : '']" id="nav-tabContent">
      <div class="tab-pane fade"
           :class="[tab.active ? 'active show' : '']"
           v-for="(tab, key) in tabs"
           :key="key"
           :id="`nav-${tab.name}`"
           role="tabpanel"
           aria-labelledby="nav-general-tab">
        <div class="row mx-0" v-if="tab.load" :class="[disableDefaultTabStructure || disableContentStructure  ? 'no-gutters' : '']">
          <div class="col" :class="[disableDefaultTabStructure || disableContentStructure ? '' : 'px-3 px-md-4 px-lg-4']">
            <template v-for="(component, componentKey) in tab.components">
              <component :is="component.stack"
                         :data="component.data"
                         :tabTitle="tab.title"
                         :tabName="tab.name"
                         :ref="tab.name"
                         :key="component.name+componentKey"
                         :component="component.name"
                         @close="$emit('close')"/>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Version: v1.0
 */

export default {
  name: 'Tabs',
  props: {
    tabs: {
      required: true,
      default: [],
    },
    tabNavigation: {
      required: false,
    },
    disableDefaultTabStructure: {
      required: false,
    },
    destroyPrevTab: {
      required: false,
    },
    disableContentStructure: {
      required: false,
    },
    padding: {
      required: false,
      default: 'pl-4',
    },
    disablePadding: {
      require: false,
    },
  },
  /**
   * @description of tabNavigation
   * When we set tabNavigation as true in parent component, tabs component can change hash of the router when user change tab that see.
   */
  methods: {
    loadTab(tab) {
      const CURRENT = this.tabs.find((tabActive) => tabActive.active === true);
      CURRENT.active = false;
      if (this.destroyPrevTab) {
        CURRENT.load = false;
      }
      this.tabs[tab].load = true;
      this.tabs[tab].active = true;
      if (this.tabNavigation) {
        this.pushNextHash(tab);
      }
      this.$emit('tabChanged', this.tabs[tab]);
    },
    pushNextHash(tab) {
      if (this.$route.hash !== `#${this.tabs[tab].name}`) {
        /**
         * @summary to prevent push route over same route.
         */
        this.$router.push({
          hash: `#${this.tabs[tab].name}`,
        });
      }
    },
  },
};
</script>

<style scoped>
.ls__nav-link {
  padding: 20px 20px;
  font-size: 16px;
}

.ls__nav-link:hover {
  color: inherit;
}

.ls__nav-link.active {
  color: inherit;
  font-weight: bold;
}

.ls__nav-link.active::before {
  background: #ed0080;
  height: 2px;
  bottom: 0;
  top: 97%;
}

.ls__nav-link.active::after {
  content: " ";
  position: absolute;
  top: 98%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #ed0080 transparent transparent transparent;
}

.mobile-scroll {
  overflow-x: auto;
  overflow-y: hidden;
}

@media only screen and (max-width: 767px) {
  .ls__nav-link {
    padding: 20px 15px 10px 15px;
    font-size: 14px;
  }
  .contact-nav-tab {
    display: flex;
    justify-content: space-between;
  }
}
.tab-icon {
  background-color: #9e9e9e;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.active-icon {
  background-color: #ed0080;
}
</style>
